/**
 * Utilitários de máscara para campos de formulário
 */

/**
 * Aplica máscara de telefone brasileiro ao valor informado.
 * Exemplo: "11987654321" → "(11) 98765-4321"
 *
 * @param {string} value - Valor a ser formatado.
 * @returns {string} Valor formatado com máscara de telefone.
 */
export function maskTelefone(value) {
    return value
        .replace(/\D/g, "")
        .replace(/(\d{2})(\d)/, "($1) $2")
        .replace(/(\d{5})(\d)/, "$1-$2")
        .replace(/(-\d{4})\d+?$/, "$1");
}

/**
 * Aplica máscara de CPF ao valor informado.
 * Exemplo: "12345678901" → "123.456.789-01"
 *
 * @param {string} value - Valor a ser formatado.
 * @returns {string} Valor formatado com máscara de CPF.
 */
export function maskCPF(value) {
    return value
        .replace(/\D/g, "")
        .slice(0, 11)
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
}

/**
 * Aplica máscara de CEP ao valor informado.
 * Exemplo: "12345678" → "12345-678"
 *
 * @param {string} value - Valor a ser formatado.
 * @returns {string} Valor formatado com máscara de CEP.
 */
export function maskCEP(value) {
    return value
        .replace(/\D/g, "")
        .replace(/(\d{5})(\d)/, "$1-$2")
        .replace(/(-\d{3})\d+?$/, "$1");
}
